import React, { useState } from 'react'
import { ArrowRight, Check } from 'lucide-react'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

function cn(...inputs: any[]) { return twMerge(clsx(inputs)) }

interface InteractiveHoverButtonProps {
  text?: string
  loadingText?: string
  successText?: string
  classes?: string
  onClick?: () => void
  children?: React.ReactNode
  hoverContent?: React.ReactNode
}

export default function InteractiveHoverButton({
  text = 'Button',
  loadingText = 'Processando...',
  successText = 'Concluído!',
  classes,
  onClick,
  children,
  hoverContent,
  ...props
}: InteractiveHoverButtonProps) {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success'>('idle')

  const isIdle = status === 'idle'

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
    
    if (status !== 'idle' || onClick) return

    setStatus('loading')
    setTimeout(() => {
      setStatus('success')
      setTimeout(() => {
        setStatus('idle')
      }, 3000)
    }, 2000)
  }

  return (
    <button
      className={cn(
        'group relative flex items-center justify-center overflow-hidden rounded-full font-semibold transition-all duration-300',
        status === 'loading' && 'px-2',
        classes
      )}
      onClick={handleClick}
      {...props}
    >
      <div
        className='flex items-center gap-2 w-full justify-center animate-in fade-in slide-in-from-bottom-2 duration-300'
      >
        <div
          className={cn(
            'bg-primary h-2 w-2 rounded-full transition-all duration-500 group-hover:scale-[60] absolute z-0',
            !isIdle && 'scale-[60]'
          )}
        />
        <span
          className={cn(
            'inline-flex items-center gap-2 transition-all duration-500 group-hover:translate-x-20 group-hover:opacity-0 relative z-10',
            !isIdle && 'translate-x-20 opacity-0'
          )}
        >
          {children || text}
        </span>
        <div
          className={cn(
            'text-primary-foreground absolute top-0 left-0 z-10 flex h-full w-full -translate-x-16 items-center justify-center gap-2 opacity-0 transition-all duration-500 group-hover:translate-x-0 group-hover:opacity-100',
            !isIdle && 'translate-x-0 opacity-100'
          )}
        >
          {status === 'idle' ? (
            hoverContent ? hoverContent : (
              <>
                <span>{typeof children === 'string' ? children : text}</span>
                <ArrowRight className='h-4 w-4' />
              </>
            )
          ) : status === 'loading' ? (
            <>
              <div className='border-primary border-t-background h-4 w-4 animate-spin rounded-full border-2' />
              <span className='text-background'>{loadingText}</span>
            </>
          ) : (
            <>
              <Check className='h-4 w-4' />
              <span>{successText}</span>
            </>
          )}
        </div>
      </div>
    </button>
  )
}
